import { render, staticRenderFns } from "./widget-container.vue?vue&type=template&id=47506997&scoped=true"
import script from "./widget-container.vue?vue&type=script&lang=js"
export * from "./widget-container.vue?vue&type=script&lang=js"
import style0 from "./widget-container.vue?vue&type=style&index=0&id=47506997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47506997",
  null
  
)

export default component.exports